module.exports = __webpack_public_path__ + "static/media/highFiveLeft.b9febbef.png";